<div class="modal d-block" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow">
      <div class="content" [formGroup]="locationForm">
        <div class="inner-content">
          <h3>Where will you be attending?</h3>

          <mat-form-field>
            <mat-label>Event Location</mat-label>
            <mat-select formControlName="eventLocationId">
              @for (c of getLocations(); track c) {
                <mat-option
                  [value]="c.eventLocationId"
                  >
                  {{ c.cityName + " - " + c.address }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="btn-row">
          <button
            type="button"
            class="new-btn secondary-btn"
            (click)="onCancelClicked()"
            >
            Cancel
          </button>
          <button
            type="button"
            class="new-btn primary-btn"
            (click)="onConfirmClicked()"
            [disabled]="locationForm.invalid"
            >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
